import { render, staticRenderFns } from "./ws8-station-offline.vue?vue&type=template&id=987adae2"
import script from "./ws8-station-offline.vue?vue&type=script&lang=js"
export * from "./ws8-station-offline.vue?vue&type=script&lang=js"
import style0 from "./ws8-station-offline.vue?vue&type=style&index=0&id=987adae2&prod&lang=less&rel=stylesheet%2Fless"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports